import { createContext } from "react";
import { WithRouterProps } from "react-router";

export const RouterContext = createContext<WithRouterProps | null>(null);